<template>
  <vs-popup class="product-order-create-popup"
            title="SALES QUOTE CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickCreateProductOrder)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/3 md:s-full w-full md:mb-0">
                  <vs-table id="create-product-order-table" :data="cartItems" stripe>
                    <template slot="header">
                    </template>
                    <template slot="thead">
                      <vs-th width="15%">PRODUCT CODE/NAME</vs-th>
                      <vs-th width="20%">CUSTOMER PRODUCT NAME</vs-th>
                      <vs-th width="10%">INCOTERM</vs-th>
                      <vs-th width="15%">QUANTITY (KG)</vs-th>
                      <vs-th width="10%">UNIT PRICE (KG/{{ account_currency }})</vs-th>
                      <vs-th width="15%">TOTAL PRICE ({{account_currency}})</vs-th>
                      <vs-th WIDTH="15%">PACK SIZE (KG)</vs-th>
<!--                      <vs-th width="15%">ACTIONS</vs-th>-->
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].product_code_name">
                          {{ data[indextr].product_code_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].customer_product_code">
                          {{ data[indextr].customer_product_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].incoterm">
                          {{ incotermsFactory(data[indextr].incoterm, indextr) }}
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
<!--                          <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="''" v-slot="{ errors }">-->
<!--                            {{ !data[indextr].is_tier ? data[indextr].quantity :  data[indextr].quantity_from + '  -  ' + data[indextr].quantity_to }}-->
<!--                          </ValidationProvider>-->
                          <span v-if="!data[indextr].is_tier">
                            {{ data[indextr].quantity }}
                          </span>
                          <span v-if="data[indextr].is_tier">
                            <span v-for="(qty_obj, index) in data[indextr].quantity_array" :key="index">
                              {{ qty_obj.quantity_from }} <br>
                            </span>
                          </span>

                        </vs-td>
                        <vs-td :data="data[indextr].unit_price">
                          <span v-if="!data[indextr].is_tier">
                            {{ data[indextr].unit_price }}
                          </span>
                          <span v-if="data[indextr].is_tier">
                            <span v-for="(price_obj, index) in data[indextr].price_array" :key="index">
                              {{ price_obj.price }} <br>
                            </span>
                          </span>
                        </vs-td>

                        <vs-td :data="data[indextr].unit_price">
                          <span v-if="!data[indextr].is_tier">
                            {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                          </span>
                          <span v-if="data[indextr].is_tier">
                            N/A
                          </span>
                        </vs-td>

                        <vs-td :data="data[indextr].pack_size">
                          {{ data[indextr].pack_size }}
                          <!-- <ValidationProvider :vid="indextr + 'pack_size' " :name="indextr + 'pack_size'" :rules="'required'" v-slot="{ errors }">
                            <vs-input
                              type="text"
                              v-model="data[indextr].pack_size" class="w-full"
                              :name="'pack_size'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                          </ValidationProvider> -->
                        </vs-td>

<!--                        <vs-td :data="data[indextr].formulation_id">-->
<!--                          <div class="vx-row">-->
<!--                          <vx-tooltip class="mr-2" :text="`Remove ${tr.formulation_code} from cart`" position="top">-->
<!--                            <vs-button @click.stop="onClickRemoveFromCart(data[indextr].id)"-->
<!--                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>-->
<!--                          </vx-tooltip>-->
<!--                            <vx-tooltip v-if="data[indextr].type === 'contract'" class="mr-2" text="Add/Update price tiers" position="top">-->
<!--                              <vs-button @click.stop="onClickCalculatePrice(data[indextr], indextr)"-->
<!--                                         size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>-->
<!--                            </vx-tooltip>-->
<!--                          </div>-->
<!--                        </vs-td>-->

                      </vs-tr>
<!--                      <vs-tr>-->
<!--                        <vs-td style="font-weight: bolder">Total</vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                        <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>-->
<!--                        <vs-td></vs-td>-->
<!--                      </vs-tr>-->
                    </template>

                  </vs-table>
                  <h3 class="my-4" v-if="applicableRules.length">Additonal Cost ( {{ applicableRules.filter((x) => x.is_selected).length }} selected items )</h3>
                  <vs-table :data="applicableRules" v-if="applicableRules.length">
                    <template slot="thead">
                      <vs-th>NAME/DESCRIPTION</vs-th>
                      <vs-th width="10%">NOMINAL CODE</vs-th>
                      <vs-th width="15%">AMOUNT (Excl VAT) in {{ account_currency }}</vs-th>
                      <vs-th width="15%">TAX CODE</vs-th>
                      <vs-th width="15%">AMOUNT (Incl VAT) in {{ account_currency }}</vs-th>
                      <vs-th width="15%"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].sage_nominal_code">
                          {{ data[indextr].sage_nominal_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].amount">
                          <vs-input v-model="data[indextr].amount"></vs-input>
                        </vs-td>

                        <vs-td>
                          <vs-dropdown>

                            <a class="flex items-center">
                              {{ tr.vat_code || 'SELECT'}}
                              <i class="material-icons"> expand_more </i>
                            </a>

                            <vs-dropdown-menu style="z-index: 99999">

                              <vs-dropdown-item @click="onClickTaxCode(tax_code.code, tax_code.percent, indextr)" v-for="(tax_code, index) in tax_codes" :key="index">
                                <span>{{tax_code.code}} - {{tax_code.percent}} % </span>
                              </vs-dropdown-item>

                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </vs-td>

                        <vs-td>
                          {{ Number(tr.amount * (1 + (Number(tr.vat_percent) / 100))).toFixed(2) }}
                        </vs-td>

                        <vs-td>
                          <vs-button @click.stop="tr.is_selected = !tr.is_selected" v-if="!tr.is_selected" size="small" icon-pack="feather" icon="icon-plus">Select</vs-button>
                          <vs-button @click.stop="tr.is_selected = !tr.is_selected" v-if="tr.is_selected" color="danger" size="small" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
            </div>

              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <vx-card>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="terms_of_payment" name="terms_of_payment" rules="required" v-slot="{ errors }">
                        <small class="label">Term of Payment (Days)</small> <small v-if="customer_data.account_type === 'proforma'" class="text-danger float-right">*Proforma Account</small>
                        <vs-input v-model="form.terms_of_payment"  name="terms_of_payment" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="valid_from" name="valid_from" rules="required" v-slot="{ errors }">
                        <small class="label">Valid From Date</small>
                        <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="form.valid_from" placeholder="Choose Date"
                        />
                        <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="form.valid_from"
                          placeholder="Choose Date"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="valid_to" name="valid_to" rules="required" v-slot="{ errors }">
                        <small class="label">Valid To Date</small>
                        <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="form.valid_to" placeholder="Choose Date"
                        />
                        <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="form.valid_to"
                          placeholder="Choose Date"
                        />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="account_manager_id" name="account_manager_id" rules="required" v-slot="{ errors }">
                        <small class="label">Account Manager</small>
                        <v-select @search="onSearchAccountManager" :clearable="true" name="account_manager_id" placeholder=""
                                  label="name" v-model="form.account_manager_id" :reduce="option => option.id"
                                  :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="no-options">
                            type to search staff
                          </template>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                <div class="vx-row mb-3" v-if="onClickAddressChange">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="delivery_address" name="delivery_address" rules="required" v-slot="{ errors }">
                      <small class="label">Select a invoice address</small>
                      <v-select
                        v-on:input="onChangeSelectInvoiceAddress"
                        name="formulation_items" placeholder=""
                        v-model="selectedAddress" :reduce="option => option"
                        label="country"
                        :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                            <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                          </div>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3" v-if="onClickAddressChange">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = false">or add delivery address</span>
                    </div>
                  </div>

                <span v-if="!onClickAddressChange">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                        <small class="label">Name</small>
                        <vs-input v-model="form.invoice_address.site_name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input v-model="form.invoice_address.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input v-model="form.invoice_address.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.invoice_address.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.invoice_address.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.invoice_address.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.invoice_address.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = true">change delivery address</span>
                      </div>
                  </div>
                </span>

                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full md:mb-0">
                      <small class="label">Is delivery address same as invoice address?</small>
                      <vs-switch v-model="form.is_delivery_same_as_invoice_address" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </div>
                  </div>

                  <div class="vx-row mb-3" v-if="!form.is_delivery_same_as_invoice_address">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
                        <small class="label">Select a delivery address</small>
                        <v-select
                          v-on:input="onChangeSelectDeliveryAddress"
                          name="formulation_items" placeholder=""
                          v-model="selectedDeliveryAddress" :reduce="option => option"
                          label="country"
                          :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>

                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="fao" name="fao" rules="" v-slot="{ errors }">
                      <small class="label">FAO</small>
                      <!-- <vs-textarea class="mb-0" v-model="form.fao" height="150px" /> -->
                      <v-select name="natural_synthetic"
                            v-model="form.fao_ids"
                            multiple
                            :options="customer_users_list" :reduce="option => option.id"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'" label="full_name"/>
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <create-customer-account-limit-request-pop-up v-bind:account_currency="'GBP'" ref="createCustomerAccountLimitRequestPopUp" />
    <customer-credit-check-pop-up v-on:openCreditLimitRequest="openCreditLimitRequest" v-on:refreshData="onlyRefreshData" v-on:onlyRefreshData="onlyRefreshData" ref="customerCreditCheckPopUp"/>
    <calculate-product-price-pop-up ref="calculateProductPricePopUp" v-bind:account_currency="account_currency"/>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const SettingsRepository = RepositoryFactory.get('settings');
  const AdditionalCostRepository = RepositoryFactory.get('additional_cost');
  const TaxRepository = RepositoryFactory.get('tax')

  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'
  import CalculateProductPricePopUp from "@/components/popups/customer/product-orders/CalculateProductPricePopUp";
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import SageFactory from "@/mixins/SageFactory";
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        fao_id: null,
        items: [],
        delivery_address: {},
        invoice_address: {},
        is_delivery_same_as_invoice_address: false,
        terms_of_payment: 0,
        valid_from: null,
        add_costs: []
      },
      countryCodes: [],
      customers: [],
      customer_users_list: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      selectedDeliveryAddress: '',
      cartItems: [],
      staffs: [],
      productCatalogues: [],
      onClickAddressChange: true,
      is_uk_based_customer: false,
      is_special_request_date: false,
      special_request_date: null,
      customer_data: {},
      sample_order_id: null,
      additional_cost_rules: [],
      applicableRules: [],
      tax_codes: [],
      fx_rate: 1
    }
  }

export default {
  name: 'CreateCustomerSampleOrderPopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {type: String,  default: ''},
  },
  methods:{
    async openPopup (id,sample_order_id, is_uk_based_customer, cartItems) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.sample_order_id = sample_order_id
        this.is_uk_based_customer = is_uk_based_customer
        this.open = true;
        await this.$vs.loading({
          container: '#create-product-order-table',
          scale: 0.45
        })
        await this.fetchTaxCodes()
        await this.fetchAddtionalCostRules()
        await this.getCountryCodes()
        await this.getAddresses()
        await this.getItemsInItemsCart(cartItems)
        await this.getCustomerDetails()
        await this.fetchCustomerUsers()
        await this.getCustomerAccountCredit()
        await this.checkRules(this.cartItems, this.additional_cost_rules)
        this.form.valid_from = moment().format('DD/MM/YYYY')
        if(this.customer_data.account_handler_id) {
          this.staffs.push({name: this.customer_data.account_handler, id: this.customer_data.account_handler_id})
          this.form.account_manager_id = this.customer_data.account_handler_id
        }
        this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
        // this.getFormulations()

      } catch (error) {

      }
    },
    onSearchAccountManager(search, loading) {
      if(search.length) {
        loading(true);
        this.searchStaff(loading, search, this);
      }
    },
    searchStaff: _.debounce( async (loading, search, vm) => {
      const {data} = await DropDownRepository.getStaffList(`filter[search]=${search}`)
      vm.staffs = data.data
      loading(false);
    }, 350),
    async refreshData() {
      this.open =false
    },
    async onlyRefreshData() {
      await this.getItemsInItemsCart()
    },
    async onClickCalculatePrice(data, index = null) {
      await this.$refs.calculateProductPricePopUp.openPopup(data, index)
    },
    async openCreditLimitRequest() {
      await this.onlyRefreshData()
      await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.id)
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    async onClickCreateProductOrder () {
      const vue = this;
      await this.$vs.loading({
        container: '#create-product-order-table',
        scale: 0.45
      })
      let order_data = {}
       try {
         this.form.customer_id = this.id
         this.form.sample_order_id = this.sample_order_id

         //lead time calculate
         let lead_time = 15;
          const country = this.form.is_delivery_same_as_invoice_address ? this.form.invoice_address.country : this.form.delivery_address.country;

          const region = country === 'Great Britain'
            ? 'product_delivery_days_uk'
            : this.countryCodes.find(x => x.name === country && x.is_europe)
              ? 'product_delivery_days_eu'
              : 'product_delivery_days_row';

          lead_time = (await SettingsRepository.getTheItem(region)).data.data[region];
         //end lead time calculator

         this.form.items = this.cartItems
           .map((m) => {
           return {
             formulation_id: m.formulation_id,
             customer_product_code: m.customer_product_code,
             product_code_name: m.product_code_name,
             quantity: m.quantity_array,
             price: m.price_array,
             pack_size: Number(m.pack_size).toFixed(3),
             lead_time: lead_time + '',
             incoterms: m.incoterm,
             valid_from: this.form.valid_from,
             valid_to: this.form.valid_to,
             estimated_yearly_volume: m.estimated_yearly_volume,
             is_tier: m.is_tier
           }
         })
         if(this.form.is_delivery_same_as_invoice_address) {
           this.form.delivery_address.site_name = this.form.invoice_address.site_name
           this.form.delivery_address.line1 = this.form.invoice_address.line1
           this.form.delivery_address.line2 = this.form.invoice_address.line2
           this.form.delivery_address.line3 = this.form.invoice_address.line3
           this.form.delivery_address.town_state = this.form.invoice_address.town_state
           this.form.delivery_address.post_code = this.form.invoice_address.post_code
           this.form.delivery_address.country = this.form.invoice_address.country
           this.form.delivery_address.email = ''
         }
        if(this.applicableRules.length) {
          this.form.add_costs = this.applicableRules.filter((x) => x.is_selected).map((x) => {
            return { name: x.name, amount: Number(x.amount).toFixed(2), vat_percent: Number(x.vat_percent).toFixed(2), sage_nominal_code_id: x.sage_nominal_code_id }
          })
        }
         order_data = (await CustomerRepository.createSalesQuote(this.form)).data.data
         this.showSuccessMessage('Sales quote created successfully')
         this.open = false;
         await vue.$parent.refreshData()
       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations =  data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
    },
    async getCustomerDetails() {
      const {data }  =  (await CustomerRepository.getCustomerDetails(this.id)).data
      this.customer_data = data      
    },
    async getCustomerAccountCredit() {
      try {
        const { data } = (await CustomerRepository.getCustomerAccountCredit(this.id)).data
        if(this.customer_data.account_type === 'proforma') {
          this.form.terms_of_payment = 0
        } else {
          this.form.terms_of_payment = data.credit_terms
        }
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async getAddresses() {
      this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.id)).data.data;
    },
    async fetchCustomerUsers() {
      const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.id)).data
      this.customer_users_list = data
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {

    },
    async getItemsInItemsCart(cartItems) {
      try {
        this.cartItems = cartItems
        this.productCatalogues = (await CustomerRepository.getListOfCartProductCatalogueSalesQuote(
          this.id,
          { formulation_ids: this.cartItems.map((x) => x.formulation_id) }, 0
        )).data.data

        if(this.productCatalogues.length) {
          this.fx_rate = this.productCatalogues[0].fx_rate
        }

        this.cartItems = this.cartItems.map((n) => {
          const find =  this.productCatalogues.find((m) => m.id === n.formulation_id)
          n.min_order_quantity = find.min_order_quantity
          n.incoterm = n.incoterm
          n.unit_price = n.price
          n.price = find.price
          n.formulation_type = find.formulation_type || ''
          return n
        })
      }catch (e) {
        this.convertAndNotifyError(e)
      }

    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#create-product-order-table',
        scale: 0.45
      })
      try {
        await CustomerRepository.removeFormulationsFromProductCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart!')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-product-order-table > .con-vs-loading')
    },
    async onClickUpdateFromCart(data) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const payload = {quantity: data.quantity, price: data.unit_price, incoterm: data.incoterm}
        await CustomerRepository.updateFormulationsQuantityInProductCart(data.id, payload)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Product item quantity updated')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    onChangeSelectInvoiceAddress(selected) {
      this.form.invoice_address.site_name = selected.name
      this.form.invoice_address.line1 = selected.line1
      this.form.invoice_address.line2 = selected.line2
      this.form.invoice_address.line3 = selected.line3
      this.form.invoice_address.town_state = selected.town_state
      this.form.invoice_address.post_code = selected.post_code
      this.form.invoice_address.country = selected.country
      this.form.invoice_address.email = ''

      // this.form.delivery_instruction = selected.additional_info
      this.onClickAddressChange = false
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.delivery_address.site_name = selected.name
      this.form.delivery_address.line1 = selected.line1
      this.form.delivery_address.line2 = selected.line2
      this.form.delivery_address.line3 = selected.line3
      this.form.delivery_address.town_state = selected.town_state
      this.form.delivery_address.post_code = selected.post_code
      this.form.delivery_address.country = selected.country
      this.form.delivery_address.email = ''

      // this.form.delivery_instruction = selected.additional_info
      this.onClickAddressChange = false
    },
    totalCalculator() {
      let total = 0;
      this.cartItems.forEach((m) => {
        if (!!m.unit_price) {
          total = total + Number(m.unit_price) * Number(m.quantity)
        }

      })
      return total.toFixed(2)
    },
    incotermsFactory(incoterm, index) {
      return incoterm
      // if(!!incoterm) {
      //   this.cartItems[index].incoterm = incoterm
      //   return incoterm
      // } else if (this.is_uk_based_customer) {
      //   this.cartItems[index].incoterm = 'DDP'
      //   return 'DDP'
      // } else {
      //   this.cartItems[index].incoterm = 'EXW'
      //   return 'EXW'
      // }
    },
    async fetchTaxCodes() {
      try {
        const { data } =  await TaxRepository.getListOfTaxCodes(1, '', 150)
        this.tax_codes = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchAddtionalCostRules() {
      const { data } = await AdditionalCostRepository.getAdditionalCostList(1, '', 50, '')
      this.additional_cost_rules = data.data
    },
    // checkRules(cartItems, rules) {
    //   const applicableRules = [];

    //   cartItems.forEach(item => {
    //       rules.forEach(rule => {
    //           if (rule.product_types.includes(item.formulation_type)) {
    //               const itemQuantity = parseFloat(item.quantity);
    //               const ruleQuantity = parseFloat(rule.quantity);
                  
    //               let conditionMet = false;
    //               switch (rule.condition) {
    //                   case "gte":
    //                       conditionMet = itemQuantity >= ruleQuantity;
    //                       break;
    //                   case "gt":
    //                       conditionMet = itemQuantity > ruleQuantity;
    //                       break;
    //                   case "lte":
    //                       conditionMet = itemQuantity <= ruleQuantity;
    //                       break;
    //                   case "lt":
    //                       conditionMet = itemQuantity < ruleQuantity;
    //                       break;
    //                   case "eq":
    //                       conditionMet = itemQuantity === ruleQuantity;
    //                       break;
    //               }
    //               if (conditionMet) {
    //                   applicableRules.push({
    //                       name: rule.name,
    //                       amount: parseFloat(rule.amount * this.fx_rate).toFixed(2),
    //                       vat_percent: "0.00",
    //                       vat_code: 'Z',
    //                       is_selected: true,
    //                       sage_nominal_code_id: rule.sage_nominal_code_id,
    //                       sage_nominal_code: rule.sage_nominal_code.code
    //                   });
    //               }
    //           }
    //       });
    //   });
    //   this.applicableRules = applicableRules
    // },
    checkRules(cartItems, rules) {
        const applicableRules = [];

        cartItems.forEach(item => {

            if (item.quantity === "tier") {
                // Handle 'tier' cases
                const quantityArray = item.quantity_array;

                if (!quantityArray || quantityArray.length === 0) {
                    // Ignore item if quantity_array is missing or has more than one object
                    return;
                }

                // Extract quantity_from and quantity_to
                const { quantity_from, quantity_to } = quantityArray[0];
                const itemQuantityFrom = parseFloat(quantity_from);
                const itemQuantityTo = parseFloat(quantity_to);

                rules.forEach(rule => {
                    if (rule.product_types.includes(item.formulation_type)) {
                        const ruleQuantity = parseFloat(rule.quantity);

                        let conditionMet = false;
                        switch (rule.condition) {
                            case "gte":
                                conditionMet = itemQuantityFrom >= ruleQuantity;
                                break;
                            case "gt":
                                conditionMet = itemQuantityFrom > ruleQuantity;
                                break;
                            case "lte":
                                conditionMet = itemQuantityTo <= ruleQuantity;
                                break;
                            case "lt":
                                conditionMet = itemQuantityTo < ruleQuantity;
                                break;
                            case "eq":
                                conditionMet = itemQuantityFrom <= ruleQuantity && itemQuantityTo >= ruleQuantity;
                                break;
                        }

                        if (conditionMet) {
                          const find_currency_price = rule.currencies.find((x) => x.currency === this.account_currency)
                            applicableRules.push({
                                name: rule.name,
                                amount: parseFloat(find_currency_price.amount).toFixed(2),
                                vat_percent: "0.00",
                                vat_code: "Z",
                                is_selected: true,
                                sage_nominal_code_id: rule.sage_nominal_code_id,
                                sage_nominal_code: rule.sage_nominal_code.code
                            });
                        }
                    }
                });
            } else {
                // Handle normal numeric quantity
                const itemQuantity = parseFloat(item.quantity);

                rules.forEach(rule => {
                    if (rule.product_types.includes(item.formulation_type)) {
                        const ruleQuantity = parseFloat(rule.quantity);

                        let conditionMet = false;
                        switch (rule.condition) {
                            case "gte":
                                conditionMet = itemQuantity >= ruleQuantity;
                                break;
                            case "gt":
                                conditionMet = itemQuantity > ruleQuantity;
                                break;
                            case "lte":
                                conditionMet = itemQuantity <= ruleQuantity;
                                break;
                            case "lt":
                                conditionMet = itemQuantity < ruleQuantity;
                                break;
                            case "eq":
                                conditionMet = itemQuantity === ruleQuantity;
                                break;
                        }

                        if (conditionMet) {
                            const find_currency_price = rule.currencies.find((x) => x.currency === this.account_currency)
                            applicableRules.push({
                                name: rule.name,
                                amount: parseFloat(find_currency_price.amount).toFixed(2),
                                vat_percent: "0.00",
                                vat_code: "Z",
                                is_selected: true,
                                sage_nominal_code_id: rule.sage_nominal_code_id,
                                sage_nominal_code: rule.sage_nominal_code.code
                            });
                        }
                    }
                });
            }
        });

        this.applicableRules = applicableRules;
    },

    onClickTaxCode(code, percentage, indextr) {
      this.applicableRules[indextr].vat_code = code
      this.applicableRules[indextr].vat_percent = percentage
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    CustomerCreditCheckPopUp,
    CreateCustomerAccountLimitRequestPopUp,
    CalculateProductPricePopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations, SageFactory],
}
</script>

<style scoped>
  .product-order-create-popup >>> .vs-popup {
    /*min-height: 80% !important;*/
    min-width: 90% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
